/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiProjectprioritiesMutationRequest,
  PostApiProjectprioritiesMutationResponse,
} from '../models/PostApiProjectpriorities.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiProjectprioritiesMutationResponseSchema,
  postApiProjectprioritiesMutationRequestSchema,
} from '../zod/postApiProjectprioritiesSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiProjectprioritiesMutationKey = () =>
  [{ url: '/api/projectpriorities' }] as const;

export type PostApiProjectprioritiesMutationKey = ReturnType<
  typeof postApiProjectprioritiesMutationKey
>;

/**
 * {@link /api/projectpriorities}
 */
export async function postApiProjectpriorities(
  data: PostApiProjectprioritiesMutationRequest,
  config: Partial<RequestConfig<PostApiProjectprioritiesMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiProjectprioritiesMutationRequestSchema.parse(data);
  const res = await request<
    PostApiProjectprioritiesMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiProjectprioritiesMutationRequest
  >({
    method: 'POST',
    url: `/api/projectpriorities`,
    data: requestData,
    ...requestConfig,
  });
  return postApiProjectprioritiesMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projectpriorities}
 */
export function usePostApiProjectpriorities<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectprioritiesMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiProjectprioritiesMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiProjectprioritiesMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectprioritiesMutationKey();

  return useMutation<
    PostApiProjectprioritiesMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiProjectprioritiesMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiProjectpriorities(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
